/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 *
 * @param {Object} section
 * @returns
 */
const FinancialSupport = ({ section, region, lang, cityId }) => {
  const sectionContent = section?.sectionContent;

  return (
    <Box
      py={{ base: '15px', md: '20px' }}
      bgColor="#F1EBDF"
      px={{ base: '7%', md: '10%' }}
    >
      <SectionTitle
        titleObj={{
          title: sectionContent[0]?.titleText,
          titleDecoration: 'flowers',
          titleSubtext: sectionContent[0]?.titleSubtext,
        }}
        w={{ base: '264px', sm: '340px' }}
        px={{ base: '7px', md: '10px' }}
        lineHeight="40px"
        color="#02026C"
        fontFamily={{
          md: 'FedraSansStd-medium',
          base: 'FedraSansStd-A-medium',
        }}
        my="0" // remove if need more space vertically
      />
      <MidContainer w={'584px'}>
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          mb="30px"
          justifyContent={{ base: 'center' }}
        >
          <Box
            // mr={{ base: '0', md: '70px' }}
            pt={{ base: '20px', lg: '1%' }}
            pb="30px"
            // m={{ base: '0 16px', lg: '0' }}
            // className="event-text"
            color="#fff"
          >
            <StructuredTextParser
              str={render(sectionContent[1]?.body)}
              color="#000000"
              mt="0"
              fontSize="16px"
              lineHeight={{ base: '26px', md: '28px' }}
              fontFamily="FedraSansStd-book"
              fontWeight="400"
              className="fSeot"
              textAlign="center"
            />
            <style global jsx>
              {`
                .fSeot p {
                  margin-bottom: 15px;
                }
                .fSeot p a,
                .fSeot a {
                  color: #c4321f;
                  text-decoration: underline;
                }
                .fSeot p strong {
                  font-family: FedraSansStd-medium, sans-serif;
                  font-weight: normal;
                  font-size: 20px;
                  line-height: 35px;
                }
              `}
            </style>
          </Box>
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default FinancialSupport;
